module.exports = __webpack_public_path__ + "static/fonts/Oxanium-SemiBold.c69d7010.ttf";